<template>
  <v-dialog v-model="show" persistent scrollable :max-width="maxWidth">
    <v-card class="p-4">
      <template v-if="!!title">
        <v-card-title>
          <v-icon color="warning">mdi-alert-circle-outline </v-icon>
          <span class="dialog-title">{{ title }}</span>
          <v-spacer />
          <v-btn icon color="grey" @click="closePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-card-text class="pl-10 pt-0">
        <div v-if="message" class="dialog-message" v-html="formattedText"></div>
        <component :is="content" v-else-if="!!content" v-bind="contentProps" />
      </v-card-text>
      <v-card-actions class="flex justify-end">
        <fragment v-if="actions">
          <v-btn
            v-for="(action, index) in actions"
            :key="index"
            class="no-uppercase"
            :color="action.color"
            :fill="action.fill"
            @click="() => action.onClick(closePopup)"
          >
            {{ action.text }}
          </v-btn>
        </fragment>
        <fragment v-else>
          <v-btn
            class="no-uppercase"
            outlined
            color="primary"
            @click="closePopup"
          >
            {{ cancelText || $t("common.base.button.cancel") }}
          </v-btn>
          <v-btn class="no-uppercase" fill color="primary" @click="onClickYes">
            {{ yesText || $t("common.base.button.yes") }}
          </v-btn>
        </fragment>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CommonUIControl from "@/helper/CommonUIControl";

export default {
  props: {
    /** If **true** the dialog will be shown. */
    show: {
      type: Boolean,
      default: false,
    },
    /** Dialog title. */
    title: {
      type: String,
      default: "",
    },
    /** Dialog message. */
    message: {
      type: String,
      default: "",
    },
    /** Use for customize dialog message. */
    content: {
      type: [Object, String],
    },
    /** Props of component was passed by **content**. */
    contentProps: {
      type: Object,
    },
    /** Dialog width. */
    maxWidth: {
      type: [String, Number],
      default: "400px",
    },
    /** The label of the button Cancel. */
    cancelText: {
      type: String,
    },
    /** The label of the button Yes. */
    yesText: {
      type: String,
    },
    /** The callback function if user click on button Yes. */
    hanldeClickYes: {
      type: Function,
      default: () => {},
    },
    hanldeClickCancel: {
      type: Function,
      default: () => {},
    },
    /** Customize dialog actions. */
    actions: {
      type: Array,
    },
  },
  computed: {
    formattedText() {
      // Replace all occurrences of \n (as plain text) with <br/>
      return (this.message || "").replace(/\\n/g, "<br/>");
    },
  },
  methods: {
    closePopup() {
      CommonUIControl.HideModalDialogConfirmV2();
      this.hanldeClickCancel();
    },
    onClickYes() {
      this.hanldeClickYes();
      this.closePopup();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
  font-size: 18px;
  font-weight: 500;
  color: var(--text-primary);
  margin-left: 15px;
}

.dialog-message {
  font-size: 14px;
  font-weight: 400;
  color: var(--text-primary);
}
</style>
